export var IStyleQuiz;
(function (IStyleQuiz) {
    let ISelectedApparelOptions;
    (function (ISelectedApparelOptions) {
        /**
         * Return an instance of ISelectedApparelOptions with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ISelectedApparelOptions.build = (partial) => (Object.assign({ options: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(ISelectedApparelOptions = IStyleQuiz.ISelectedApparelOptions || (IStyleQuiz.ISelectedApparelOptions = {}));
    /**
     * Contains all apparel ratio for "How much of your inventory is apparel or footwear" question
     * during apparel style quiz v2.
     */
    let ApparelRatio;
    (function (ApparelRatio) {
        ApparelRatio["APPAREL_RATIO_UNKNOWN"] = "APPAREL_RATIO_UNKNOWN";
        ApparelRatio["ALL"] = "ALL";
        ApparelRatio["MOST"] = "MOST";
        ApparelRatio["SOME"] = "SOME";
        ApparelRatio["NONE"] = "NONE";
        ApparelRatio["UNANSWERED"] = "UNANSWERED";
    })(ApparelRatio = IStyleQuiz.ApparelRatio || (IStyleQuiz.ApparelRatio = {}));
    let StyleQuizStoreType;
    (function (StyleQuizStoreType) {
        StyleQuizStoreType["STYLE_QUIZ_STORE_TYPE_UNKNOWN"] = "STYLE_QUIZ_STORE_TYPE_UNKNOWN";
        StyleQuizStoreType["OTHER"] = "OTHER";
        StyleQuizStoreType["GIFT"] = "GIFT";
        StyleQuizStoreType["CLOTHING"] = "CLOTHING";
        StyleQuizStoreType["HOME_DECOR"] = "HOME_DECOR";
        StyleQuizStoreType["SPA_OR_SALON"] = "SPA_OR_SALON";
        StyleQuizStoreType["GENERAL"] = "GENERAL";
        StyleQuizStoreType["FLORIST_OR_GARDEN"] = "FLORIST_OR_GARDEN";
        StyleQuizStoreType["KIDS_OR_TOY"] = "KIDS_OR_TOY";
        StyleQuizStoreType["CAFE_OR_RESTAURANT"] = "CAFE_OR_RESTAURANT";
        StyleQuizStoreType["FITNESS_OR_YOGA"] = "FITNESS_OR_YOGA";
        StyleQuizStoreType["FURNITURE"] = "FURNITURE";
        StyleQuizStoreType["PET"] = "PET";
        StyleQuizStoreType["BOOK"] = "BOOK";
        StyleQuizStoreType["GROCERY_OR_LIQUOR"] = "GROCERY_OR_LIQUOR";
        StyleQuizStoreType["STATIONERY"] = "STATIONERY";
        StyleQuizStoreType["KIDS_AND_BABY"] = "KIDS_AND_BABY";
    })(StyleQuizStoreType = IStyleQuiz.StyleQuizStoreType || (IStyleQuiz.StyleQuizStoreType = {}));
    let IStoreTypeName;
    (function (IStoreTypeName) {
        /**
         * Return an instance of IStoreTypeName with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IStoreTypeName.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IStoreTypeName = IStyleQuiz.IStoreTypeName || (IStyleQuiz.IStoreTypeName = {}));
    /**
     * Return an instance of IStyleQuiz with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IStyleQuiz.build = (partial) => (Object.assign({ categories: [], category_path_identifiers: [], styles: [], brand_tokens: [], apparel_answers: {}, secondary_store_types: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IStyleQuiz || (IStyleQuiz = {}));
